import React, { useState } from "react";
import SearchableSelect from "./SearchableSelect";
import { debounce, omit } from "lodash";
import DateFilter from "./DateFilter";
import SnapshotDateFilter from "./SnapshotDateFilter";
import SelectFilter from "./SelectFilter";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { useTranslation } from "react-i18next";

const filterFetcher = (endpoint, reportId, params) => {
  return debounce((inputValue, callback) => {
    schedulingFetchGet<any[]>(`reports/${reportId}/filters${endpoint}`, {
      query: inputValue,
      ...params,
    })
      .then((response) => {
        callback(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, 250);
};

const Filters = ({ reportId, filters, values, onChange }) => {
  const [showFilters, setShowFilters] = useState(false);
  const { t } = useTranslation();

  const toggleFiltersModal = () => {
    setShowFilters((old) => !old);
  };

  const filtersHash = new URLSearchParams(values);
  filtersHash.delete("page");
  filtersHash.delete("per_page");

  const renderFilter = (filter) => {
    const { name } = filter;

    const filterValuesHash = {};
    for (const [key, value] of values.entries()) {
      filterValuesHash[key] = value;
    }

    switch (filter?.type) {
      case "comparison_period":
      case "period":
        return (
          <DateFilter
            title={filter.title}
            value={{
              [name]: values.get(name),
              [`${name}_start_date`]: values.get(`${name}_start_date`),
              [`${name}_end_date`]: values.get(`${name}_end_date`),
            }}
            options={filter.options}
            queryName={name}
            onChange={onChange}
          />
        );
      case "date":
        return (
          <SnapshotDateFilter
            title={t(filter.title)}
            value={values.get(name)}
            queryName={name}
            onChange={onChange}
          />
        );
      case "select":
        return (
          <SelectFilter
            title={t(filter.title)}
            value={values.get(name)}
            options={filter.options}
            queryName={name}
            isClearable={!filter.primary}
            onChange={(value) => {
              onChange(value);
              if (showFilters) {
                toggleFiltersModal();
              }
            }}
          />
        );
      case "searchable_select":
        return (
          <SearchableSelect
            title={t(filter.title)}
            onChange={onChange}
            placeholder={t(filter.title)}
            defaultValue={{
              label: t(values.get(`${name}_name`)),
              value: values.get(name),
            }}
            loadOptions={filterFetcher(
              filter.endpoint,
              reportId,
              omit(filterValuesHash, name),
            )}
            queryName={name}
            allQueryParams={filtersHash}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {filters.map((filter) => {
        return renderFilter(filter);
      })}
    </>
  );
};

export default Filters;
